import _ from 'lodash';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSelectorBasedStoreValue } from 'v2/modules/withRunForm/redux/selector';
import { setRootValue } from 'v2/modules/withRunForm/redux/actions';
import { ORDER_TYPES } from 'v2/common/constants/index';
import { onChangeOrderType } from '../../events/orderType';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap-old';
import ApplicationDomainUtility from 'v3/common/utils/applicationDomain';

const OrderType = () => {
  const dispatch = useDispatch();
  const orderType = useSelector((state) => getSelectorBasedStoreValue(state, 'orderType'));
  const runType = useSelector((state) => getSelectorBasedStoreValue(state, 'runType'));
  const quantConfig = useSelector((state) => getSelectorBasedStoreValue(state, 'quantConfig'));
  const isStrategyAuthor = useSelector((state) => getSelectorBasedStoreValue(state, 'isStrategyAuthor'));
  const onUpdateOrderType = (value) =>
    dispatch(
      setRootValue(
        onChangeOrderType({
          quantConfig,
          orderType: value,
          runType,
          isStrategyAuthor,
        })
      )
    );

  // TODO, move to applicaiton domain
  const allowedOrderTypes = _.filter(ORDER_TYPES, (type) => 
     ApplicationDomainUtility.eligibleOrderType().includes(type.value)
  );

  const renderSelectOption = (orderTypeArg) => {
    if (orderTypeArg.value === ORDER_TYPES.oneClick.value) return null;
    return (
      <ToggleButton
        key={orderTypeArg.value}
        className={` ${orderType === orderTypeArg.value ? 'active' : ''}`}
        value={orderTypeArg.value}
        onClick={() => onUpdateOrderType(orderTypeArg.value)}
      >
        {orderTypeArg.displayName}
      </ToggleButton>
    );
  };

  return (
    <div className="order-type-input d-grid">
      <label className="label_style mb-1">Order Type</label>
      <ToggleButtonGroup
        className="btn-group btn-group-sm btn-group-toggle d-flex align-items-center"
        data-toggle="buttons"
        type="radio"
        size="sm"
        name="group-selector"
        value={orderType}
      >
        {_.map(Object.values(allowedOrderTypes), (orderTypeArg) => renderSelectOption(orderTypeArg))}
      </ToggleButtonGroup>
    </div>
  );
};

export default OrderType;
